import { Money } from '@/components/text';
import { CloseButton } from '@/components/ui/close-button';
import { ActionBar, Button, Portal, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PendingCommissionsActionBarProps {
  selectedCount: number;
  totalAmountSelected: number;
  currency: string;
  onPaySelected: () => void;
  onClose: () => void;
  isOpen: boolean;
  isLoading?: boolean;
}

export const PendingCommissionsActionBar: React.FC<PendingCommissionsActionBarProps> = ({
  selectedCount,
  totalAmountSelected,
  currency,
  onPaySelected,
  onClose,
  isOpen,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <ActionBar.Root open={isOpen}>
      <Portal>
        <ActionBar.Positioner zIndex="modal">
          <ActionBar.Content>
            <Text fontSize="13px" color="whiteAlpha.900" display="inline-flex" gap={1}>
              {t('commissions.actionBar.commissionsSelected', { count: selectedCount })}
            </Text>
            <ActionBar.Separator mx={1} />
            <Button
              variant="subtle"
              size="xs"
              h={8}
              minW={8}
              px={3}
              rounded="md"
              onClick={onPaySelected}
              loading={isLoading}
              disabled={isLoading}
              data-action-bar-primary
            >
              {t('commissions.actionBar.proceedToPayout')}
              {selectedCount > 0 && (
                <Money
                  fontSize="13px"
                  fontWeight="medium"
                  value={totalAmountSelected}
                  currency={currency}
                />
              )}
            </Button>
            <ActionBar.Separator ml={1} />
            <CloseButton
              size="xs"
              h={8}
              minW={8}
              borderColor="whiteAlpha.300"
              color="whiteAlpha.800"
              aria-label={t('common.close')}
              onClick={onClose}
              data-action-bar-close
              _hover={{ bg: 'whiteAlpha.200', color: 'white' }}
              _active={{ bg: 'whiteAlpha.300' }}
            />
          </ActionBar.Content>
        </ActionBar.Positioner>
      </Portal>
    </ActionBar.Root>
  );
};
